import { render, staticRenderFns } from "./RefundTicket.vue?vue&type=template&id=32734ae5&scoped=true&"
import script from "./RefundTicket.vue?vue&type=script&lang=js&"
export * from "./RefundTicket.vue?vue&type=script&lang=js&"
import style0 from "./RefundTicket.vue?vue&type=style&index=0&id=32734ae5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32734ae5",
  null
  
)

export default component.exports